import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clickOutside from 'react-click-outside';

import ProfileIntro from './ProfileIntro/index';
import ProfileExtras from './ProfileExtras/index';
import styles from './desktopDoctorPopUp.module.css';
import { doctorPropType } from '../propTypes/index';

class DesktopDoctorPopUp extends Component {
  handleClickOutside = () => this.props.close();
  render() {
    const { doctor, isFetching } = this.props;
    return (
      <div className={styles.container}>
        <ProfileIntro
          url={doctor.Picture}
          name={doctor.Name}
          initials={doctor.Name}
          title={doctor.Title}
          isFetching={isFetching}
        />
        <ProfileExtras blurb={doctor.Description} doctor={doctor} />
      </div>
    );
  }
}

DesktopDoctorPopUp.propTypes = {
  doctor: doctorPropType.isRequired,
  isFetching: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

export default clickOutside(DesktopDoctorPopUp);
